import { render } from "./StaticChart.vue?vue&type=template&id=e3c6d8e4&ts=true"
import script from "./StaticChart.vue?vue&type=script&lang=ts"
export * from "./StaticChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__